import {LonerOutroView} from "../../base/LonerOutroView";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Loner} from "../../../Loner";
import {gsap} from "gsap";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {LonerSound} from "../../../sound/LonerSound";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class LonerSSDOutroView extends LonerOutroView {

    public static FREESPIN_OUTRO_SPINS_PLAYED_STYLE:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "40px",
        fill : "#ffeb42",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20,
        stroke: "#763614",
        strokeThickness: 6
    };
    public static BET_MULTIPLIED_TEXT_POSITION:PIXI.Point = new PIXI.Point(360, 505);
    public static SHOTS_FIRED_TEXT_POSITION:PIXI.Point = new PIXI.Point(360, 544);

    private _shotsFiredText:PIXI.Text;
    private _shotsFiredTextTranslation:string;
    private _winnerWinnerSprite:PIXI.Sprite;
    private _chickenDinnerSprite:PIXI.Sprite;
    private _bigDuckSprite:PIXI.Sprite;
    private _energySprite:PIXI.Sprite;
    private _whatTheSprite:PIXI.Sprite;
    private _duckSprite:PIXI.Sprite;
    private _assetsContainer:PIXI.Container;
    private _SSDOutroHouseSprite:PIXI.Sprite;

    constructor() {
        super();
        this.name = "LonerSSDOutroView";
    }

    protected init():void {
        super.init();

        this._betMultipliedText = new PIXI.Text("", LonerSSDOutroView.FREESPIN_OUTRO_SPINS_PLAYED_STYLE);
        this._betMultipliedText.position = LonerSSDOutroView.BET_MULTIPLIED_TEXT_POSITION;
        this._betMultipliedText.anchor.set(0.5, 0.5);
        this._betMultipliedText.alpha = 0;
        this._betMultipliedText.visible = false;

        this._shotsFiredTextTranslation = Loner.apiPlugin.translations.translate("SHOTS FIRED");

        this._shotsFiredText = new PIXI.Text("", LonerSSDOutroView.FREESPIN_OUTRO_SPINS_PLAYED_STYLE);
        this._shotsFiredText.position = LonerSSDOutroView.SHOTS_FIRED_TEXT_POSITION;
        this._shotsFiredText.anchor.set(0.5, 0.5);
        this._shotsFiredText.scale.set(0.5, 0.5);
        this._shotsFiredText.alpha = 0;
        this._shotsFiredText.visible = false;

        this._assetsContainer = new PIXI.Container();
        this._assetsContainer.alpha = 0;
        this._assetsContainer.visible = false;

        this._winnerWinnerSprite = this.createSpriteByName("outro/winner winner", new PIXI.Point(360, 196), "winnerWinner");
        this._chickenDinnerSprite = this.createSpriteByName("outro/chicken_dinner", new PIXI.Point(360, 436), "chickenDinner");
        this._bigDuckSprite = this.createSpriteByName("outro/big_duck", new PIXI.Point(360, 199), "bigDuck");
        this._energySprite = this.createSpriteByName("outro/energy", new PIXI.Point(360, 436), "energy");
        this._whatTheSprite = this.createSpriteByName("outro/what_the", new PIXI.Point(360, 196), "whatThe");
        this._duckSprite = this.createSpriteByName("outro/duck", new PIXI.Point(360, 436), "onlyDuck");

        this._SSDOutroHouseSprite = new PIXI.Sprite(Loner.assetLoader.getTextures("outro/dlagonhouse")[0]);
        this._SSDOutroHouseSprite.position.set(360, 346);
        this._SSDOutroHouseSprite.anchor.set(0.5);
        this._SSDOutroHouseSprite.visible = false;
        this._SSDOutroHouseSprite.name = "SSDHouseOutro";
        this._outroContainer.addChild(this._SSDOutroHouseSprite);

        this._outroContainer.addChild(this._countUp);
        this._assetsContainer.addChild(this._betMultipliedText, this._shotsFiredText, this._winnerWinnerSprite, this._chickenDinnerSprite, this._bigDuckSprite, this._energySprite, this._whatTheSprite, this._duckSprite);
        this.addChild(this._assetsContainer);
        this.onResize();
    }

    public getCountUp(amount:number, countDuration:number = 5.5, isWinBelowStake:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{gsap.to(this._countUp, {duration : 0.4, alpha : 1})});

        if(isWinBelowStake) {
            countDuration = 0.001;
        }
        if(!isWinBelowStake) {
            tl.add(() => Loner.soundPlayer.startCountUp());
        }
        tl.add(() => {
            this._countUp.startFlicker()
        });
        tl.add([
            this._countUp.getCountAnimation(0, amount, countDuration)
        ]);
        if(!isWinBelowStake) {
            tl.add(() => Loner.soundPlayer.stopCountUp());
        }
        tl.add(() => {
            Loner.keypadPlugin.setWin(Loner.model.accumulatedRoundWin, true, isWinBelowStake);
        })

        return tl;
    }

    public showOutro(callback:Function):gsap.core.Timeline {
        this._countUp.position.y = this.getCountUpYPos();
        this._clickCallback = callback;
        const tl:gsap.core.Timeline = new gsap.core.Timeline({delay : 1});
        tl.add(() => {
            if(Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.SSD_MAX_SYM_PASSING_BY)?.isPlaying){
                Loner.soundPlayer.player.stopTrack(LonerSound.SSD_MAX_SYM_PASSING_BY);
            }
            Loner.soundPlayer.playSound(LonerSound.SSD_INITIAL_IMPACT_SOUND);
            this._SSDOutroHouseSprite.visible = true;
            this._countUp.visible = true;
            this.visible = true;
            this._betMultipliedText.text = SlotGame.apiPlugin.currency.format(Loner.model.gameData.playedBetValue) + " x " + Loner.model.totalBonusWin;
            this._shotsFiredText.text = Loner.model.gameData.numberOfFreespinsPlayed + " " + this._shotsFiredTextTranslation;
        });
        tl.add(() => {gsap.to(this._outroContainer, {duration : 0.2, alpha : 1})});

        return tl;
    }

    public showAssets():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline(),
            winRatio:number = Loner.model.wasFeatureBuy ? Loner.model.accumulatedRoundWin / Loner.getBuyFeaturePrice() : Loner.model.accumulatedRoundWin / Loner.model.playedBetValue;

        this._whatTheSprite.visible = false;
        this._duckSprite.visible = false;
        this._winnerWinnerSprite.visible = false;
        this._chickenDinnerSprite.visible = false;
        this._bigDuckSprite.visible = false;
        this._energySprite.visible = false;

        if(winRatio < (Loner.model.wasFeatureBuy ? 2 : 25)) {
            this._whatTheSprite.visible = true;
            this._duckSprite.visible = true;
        } else if(winRatio < (Loner.model.wasFeatureBuy ? 5 : 100)) {
            this._winnerWinnerSprite.visible = true;
            this._chickenDinnerSprite.visible = true;
        } else {
            this._bigDuckSprite.visible = true;
            this._energySprite.visible = true;
        }
        tl.add(()=>{
           this._assetsContainer.alpha = 0;
           this._assetsContainer.visible = true;
        });
        tl.add(gsap.to(this._assetsContainer, {duration : 0.1, alpha : 1}));
        tl.add(()=>{
            this._betMultipliedText.alpha = 0;
            this._betMultipliedText.visible = true;
            this._shotsFiredText.alpha = 0;
            this._shotsFiredText.visible = true;
        });
        tl.add(gsap.timeline({delay:0.5}));
        tl.add([
            gsap.to(this._betMultipliedText, {duration : 1, alpha : 1}),
            gsap.to(this._shotsFiredText, {duration : 1, alpha : 1})
        ]);
        return tl;
    }

    public hideOutro(isWinBelowStake:boolean):gsap.core.Timeline {
        Loner.allReelView.enableAllViews();
        Loner.foregroundView.setMode(LonerGameMode.BACK_FROM_SSD);

        const hideTL:gsap.core.Timeline = gsap.timeline();
        hideTL.add(
            () => {
                this._betMultipliedText.visible = false;
                this._shotsFiredText.visible = false;
                this._assetsContainer.visible = false;
                this._SSDOutroHouseSprite.visible = false;
                this._countUp.visible = false;
            }
        );
        hideTL.add(() => {Loner.tvMessageView.show()});
        hideTL.add(super.hideOutro(isWinBelowStake));

        return hideTL;
    }

    protected getOutroContainerPos():PIXI.Point {
        return new PIXI.Point(0, 0);
    }

    protected getCountUpYPos() {
        return 336;
    }

    private createSpriteByName(texture:string, pos:PIXI.Point, name:string, scale:number = 0.75):PIXI.Sprite {
        const sprite:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures(texture)[0]);
        sprite.position = pos;
        // sprite.alpha=0;
        sprite.visible = false;
        sprite.name = name;
        sprite.anchor.set(0.5);
        sprite.scale.set(scale);
        return sprite;
    }
}